export default __webpack_public_path__ + "static/media/fb_btn.90d21754.png";